/* Hierarchy Studio: site-wide finishing touches.
   1. Lacquer product cards: splits a card title at the dash into a gold name and a small second line.
   2. Marks the heading of every section that shows product cards.
   3. Keeps the header menu text on exactly the same line as the currency text on the right.
   4. Lacquer shine: places the soft diagonal band differently on every card, as if one lamp
      hung above and to the left of the page (further right in the right columns, weaker in lower rows). */
(function () {
  if (window.hsCards) return;
  var DASH = ' — ';
  var root = document.documentElement;

  function loadFont() {
    if (document.querySelector('link[data-hs-font]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,wght@1,600&display=swap';
    link.setAttribute('data-hs-font', '1');
    document.head.appendChild(link);
  }

  function buildTitle(el) {
    if (el.querySelector('.hs-card-main')) return;
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return;
    var cut = text.indexOf(DASH);
    var mainText = cut > 0 ? text.slice(0, cut) : text;
    var subText = cut > 0 ? text.slice(cut + DASH.length) : '';

    var main = document.createElement('span');
    main.className = 'hs-card-main' + (subText ? '' : ' hs-card-main--solo');
    main.textContent = mainText;
    el.textContent = '';
    el.appendChild(main);
    if (subText) {
      var dash = document.createElement('span');
      dash.className = 'visually-hidden';
      dash.textContent = DASH;
      var sub = document.createElement('span');
      sub.className = 'hs-card-sub';
      sub.textContent = subText;
      el.appendChild(dash);
      el.appendChild(sub);
    }
  }

  function findHeading(section) {
    var list = section.querySelectorAll('h1, h2, h3, h4');
    for (var i = 0; i < list.length; i++) {
      if (!list[i].closest('product-card')) return list[i];
    }
    return null;
  }

  function markSectionHeadings() {
    var sections = document.querySelectorAll('.shopify-section');
    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];
      if (!section.querySelector('product-card')) continue;
      var heading = findHeading(section);
      if (!heading || heading.classList.contains('hs-section-title')) continue;
      if (heading.querySelector('.hs-title-main')) continue;
      heading.classList.add('hs-section-title');
    }
  }

  function shown(el) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function setVar(el, name, value) {
    if (el.style.getPropertyValue(name) !== value) el.style.setProperty(name, value);
  }

  /* One lamp above and to the left of the page: the band of shine sits near the left edge on cards
     in the left column, further right on cards to the right, and is lower and weaker in lower rows. */
  function placeGlare() {
    try {
      var cards = document.querySelectorAll('product-card');
      if (!cards.length) return;
      var pageWidth = root.clientWidth || window.innerWidth || 1;
      var sections = [];
      var lists = [];
      var i, s, m;
      for (i = 0; i < cards.length; i++) {
        var rect = cards[i].getBoundingClientRect();
        if (!rect.width || !rect.height) continue;
        var section = cards[i].closest('.shopify-section') || document.body;
        var k = sections.indexOf(section);
        if (k < 0) { sections.push(section); lists.push([]); k = sections.length - 1; }
        lists[k].push({ el: cards[i], x: (rect.left + rect.width / 2) / pageWidth, top: rect.top });
      }
      for (s = 0; s < lists.length; s++) {
        var tops = [];
        for (m = 0; m < lists[s].length; m++) tops.push(lists[s][m].top);
        tops.sort(function (a, b) { return a - b; });
        var rowStarts = [];
        for (m = 0; m < tops.length; m++) {
          if (!rowStarts.length || tops[m] - rowStarts[rowStarts.length - 1] > 40) rowStarts.push(tops[m]);
        }
        for (m = 0; m < lists[s].length; m++) {
          var item = lists[s][m];
          var row = 0;
          for (var r = 0; r < rowStarts.length; r++) {
            if (item.top >= rowStarts[r] - 1) row = r;
          }
          if (row > 3) row = 3;
          var x = Math.max(0, Math.min(1, item.x));
          var pos = 22 + x * 46 + row * 9;
          var alpha = 0.07 - row * 0.012;
          setVar(item.el, '--hs-glare-pos', pos.toFixed(1) + '%');
          setVar(item.el, '--hs-glare-a', alpha.toFixed(3));
        }
      }
    } catch (error) {
      /* cards keep the default band */
    }
  }

  /* Measures how far the menu text sits from the currency text and stores the difference
     on the page root, where the header component cannot overwrite it. */
  function alignMenu() {
    try {
      var header = document.querySelector('#header-component');
      if (!header) return;
      var titles = header.querySelectorAll('.menu-list__link-title');
      var title = null;
      for (var i = 0; i < titles.length; i++) {
        if (shown(titles[i])) { title = titles[i]; break; }
      }
      var target = header.querySelector('.dropdown-localization__button .currency-code');
      if (!shown(target)) target = header.querySelector('.dropdown-localization__button');
      if (!shown(target)) target = header.querySelector('.header-actions__action .svg-wrapper');
      if (!title || !shown(target)) return;

      root.style.setProperty('--hs-menu-shift', '0px');
      var a = title.getBoundingClientRect();
      var b = target.getBoundingClientRect();
      var shift = (b.top + b.height / 2) - (a.top + a.height / 2);
      if (Math.abs(shift) > 40) shift = 0;
      root.style.setProperty('--hs-menu-shift', shift.toFixed(2) + 'px');
    } catch (error) {
      root.style.removeProperty('--hs-menu-shift');
    }
  }

  function refresh() {
    try {
      var titles = document.querySelectorAll('product-card [role="heading"]');
      for (var i = 0; i < titles.length; i++) buildTitle(titles[i]);
      markSectionHeadings();
    } catch (error) {
      /* cards stay in their plain form */
    }
    placeGlare();
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; refresh(); });
  }

  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { alignMenu(); placeGlare(); }, 150);
  }

  window.hsCards = { refresh: refresh, alignMenu: alignMenu, placeGlare: placeGlare };
  loadFont();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(); alignMenu(); });
  }
  refresh();
  alignMenu();
  window.addEventListener('load', function () { alignMenu(); placeGlare(); });
  window.addEventListener('resize', onResize);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { alignMenu(); placeGlare(); });
  setTimeout(function () { alignMenu(); placeGlare(); }, 600);
  setTimeout(function () { alignMenu(); placeGlare(); }, 2000);
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();
